import axios from "api/axios"
import { APIResponse, Config } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { CartlessOrder, UserOrganizations } from "./types"
import { urls } from "./urls"

export default {
  list: async (): Promise<APIResponse<UserOrganizations[]>> => {
    try {
      const res = await axios.get(urls.growthspace.list())
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  createTransaction: async ({
    params,
  }: Config): Promise<APIResponse<CartlessOrder>> => {
    try {
      const res = await axios.get(urls.growthspace.createTransaction(), {
        params,
      })
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
